
    var riot = require('riot')
    import route from 'riot-route';
import * as constant from '@common/constant';
riot.tag2('password', '<h2>パスワードの再設定</h2> <form class="pure-form pure-form-stacked" onsubmit="{formSubmit}"> <p>ご登録のメールアドレス宛に、パスワード再設定についてのメールをお送りします。</p> <div class="kf-form-group"> <label for="mail">ご登録のメールアドレス</label> <input class="pure-input-1" id="mail" ref="mail" required type="email"> </div> <button class="pure-button pure-button-success kf-block">パスワード再設定メールを送信</button> </form> <div class="link"> <a href="#login"><span class="back">ログイン画面へ</span></a> </div>', '', '', function(opts) {
    this.formSubmit = e => {
      e.preventDefault();
      this.action
        .changePassRequest({
          mail: this.refs.mail.value
        });
    };
});

riot.tag2('pass-change', '<h2>パスワードの新規設定</h2> <form class="pure-form pure-form-stacked" onsubmit="{formSubmit}"> <p>新しいパスワードを入力してください。</P> <div class="kf-form-group"> <label for="password">新しいパスワード</label> <input class="pure-input-1" type="password" id="password" ref="password" required> </div> <div class="kf-form-group"> <label for="checkPassword"> <input type="checkbox" onchange="{checkPassword}" id="checkPassword"> パスワードを表示する </label> </div> <button class="pure-button pure-button-success kf-block">パスワードを変更する</button> </form>', '', '', function(opts) {
    this.mixin('password');
    this.formSubmit = e => {
      e.preventDefault();
      this.action
        .changePass({
          password: this.refs.password.value,
          key: this.opts.key
        });
    };
});

riot.tag2('pass-complete', '<p>メールアドレスにパスワード新規設定用のメールを送信しました。</p> <a href="#login">ログイン画面はこちら</a>', '', '', function(opts) {
});
    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('password')
riot.reload('pass-change')
riot.reload('pass-complete')
    }
  }
  